document.querySelectorAll('[data-brass-feet-product]').forEach((root) => {
  const media = Array.from(root.querySelectorAll('[data-brass-media]'));
  const thumbs = Array.from(root.querySelectorAll('[data-brass-thumb]'));
  const picker = root.querySelector('[data-brass-picker]');
  const showMedia = (id) => {
    if (!media.some((item) => item.dataset.brassMedia === id)) return;
    media.forEach((item) => item.classList.toggle('is-active', item.dataset.brassMedia === id));
    thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb.dataset.brassThumb === id)));
  };
  if (media.length) {
    if (!media.some((item) => item.classList.contains('is-active'))) media[0].classList.add('is-active');
    root.classList.add('is-ready');
    const controls = root.querySelector('[data-brass-thumbs]');
    if (controls) controls.hidden = false;
  }
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.brassThumb)));
  if (picker) picker.addEventListener('change', () => {
    const option = picker.options[picker.selectedIndex];
    if (!option) return;
    root.querySelector('[data-brass-price]').textContent = option.dataset.price;
    const compare = root.querySelector('[data-brass-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const submit = root.querySelector('[data-brass-submit]');
    submit.disabled = option.dataset.available !== 'true';
    submit.textContent = submit.disabled ? 'Sold Out' : 'Add to Cart';
    showMedia(option.dataset.media);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});
